// extracted by mini-css-extract-plugin
export default {"Newsletter":"ZNs4MIEG58YPjZ0utRlY","Newsletter__content":"Evg3hUaeZqjohJqLCmWV","Newsletter__usp":"iWog766_SfRqDBz6cWhk","Newsletter__form":"oOj4bGWyJPpiH1o3syIB"};